<div class="modal-body p-4">
  <div class="d-flex">
    <div class="action-icon">
      <i *ngIf="Action.actionIcon" class="bi fs-3 me-3 {{ Action.actionIcon }}"></i>
    </div>
    <div>
      <h5 class="mt-2">
        <b>{{ ConfirmationTitle || 'Are you sure ?' }}</b>
      </h5>
      <p class="text-secondary" [innerHTML]="ConfirmationMessage"></p>
    </div>
  </div>
  <div class="d-flex gap-3 justify-content-end">
    <button type="button" class="btn btn-outline-secondary" (click)="activeModal.close(false)">Cancel</button>
    <button type="button" class="btn {{ Action.actionClass || 'btn-primary' }}" (click)="activeModal.close(true)">
      {{ Action.actionName || 'Yes' }}
    </button>
  </div>
</div>
